export {default} from './TipsScreenEmpty';
